import { render, staticRenderFns } from "./TopNavbar.vue?vue&type=template&id=40758cc4&"
import script from "./TopNavbar.vue?vue&type=script&lang=js&"
export * from "./TopNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40758cc4')) {
      api.createRecord('40758cc4', component.options)
    } else {
      api.reload('40758cc4', component.options)
    }
    module.hot.accept("./TopNavbar.vue?vue&type=template&id=40758cc4&", function () {
      api.rerender('40758cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/dashboard/TopNavbar.vue"
export default component.exports